<template>
  <Layout>
    <div class="container">
      <h3 class="page-title">{{webcast.title}}</h3>
      <ul class="qna-list" v-if="qnaItems.length">
        <li class="qna-list__item" v-for="qna in qnaItems" :class="{'answered': qna.isAnswered}">
          <Card>
            <!-- qna-header -->
            <div class="qna-header">
              <!-- qna-person-info -->
              <div class="qna-person-info">
                <span class="qna-name">{{ qna.name }}</span>
                <span class="qna-location">{{ qna.location }}</span>
              </div>
          
              <div class="qna-created-info">
                <span>{{ qna.createdAt | moment('hh:mm') }}</span>
              </div>
            </div>
          
            <!-- .qna-body -->
            <div class="qna-body">
              <div class="qna-content">{{ qna.text }}</div>
              <Button @click="markAsAnswered(qna)" class="answered-btn" :class="{'answered': qna.isAnswered}">
                <template v-if="qna.isAnswered">
                  Mark as Not Answered
                </template>

                <template v-else>Mark as Answered</template>
              </Button>
            </div>
          </Card>
        </li>
      </ul>
    </div>
  </Layout>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex'

  import moment from 'moment'
  import feathersClient from '../api/feathers-client'

  export default {
    data () {
      return {
      }
    },

    computed: {
      ...mapGetters('qna', {
        findQuestionsInStore: 'find',
      }),
      ...mapGetters('webcast', {
        webcast: 'getCopy'
      }),
      qnaItems () {
        return this.findQuestionsInStore({
          query:{
            webcastId: this.webcast._id,
            bucket: 'inbox',
            isApproved: true
          }
        }).data
      },
    },

    methods: {
      ...mapActions('qna', {
        questionList: 'find',
        createQuestionAction: 'create',
        patchQuestionAction: 'patch'
      }),

      getQuestionList(query, page) {
        query.webcastId = this.webcast._id;

        this.questionList({
          query: query
        }).then((response) => {
          //console.log(response);
        });
      },

      markAsAnswered (qna) {
        this.patchQuestionAction([qna['_id'], {isAnswered: !qna.isAnswered}])
      }
    },

    created () {
      this.getQuestionList({})
      let self = this;
      feathersClient.io.on('connect', function() {
        self.getQuestionList({});
      });
    }
  }
</script>

<style lang="scss" scoped>
  .page {
    &-title {
      margin-bottom: 30px;
    }
  }

  .container {
    margin-top: 30px;
  }

  .answered-btn {
    color: #fff;
    background-color: #e13d13;
    position: absolute;
    right: 15px;
    top: 72px;
    &:hover {
      opacity: 0.6;
      color: #fff;
      border-color: #e13d13;
      background-color: #e13d13;
    }
    &.answered {
      background-color: #2d8cf0;
      &:hover {
        border-color: #2d8cf0;
        background-color: #2d8cf0;
      }
    }
  }

  .qna {
    &-header {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    &-content{
      padding-right:200px;
    }

    &-body {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }

    &-list {
      list-style: none;
      margin-bottom: 64px;
      &__item {
        &.answered {
          .ivu-card {
            background-color: #F6F6F6;
          }
        }
      }
    }

    &-action {
      &-change {
        font-size: 14px;
        text-transform: inherit;
        padding: 0;
        color: #337AB7;
        &:focus {
          box-shadow: none;
        }
      }
    }

    &-name {
      color: #367DB8;
      &--action {
        font-weight: bold;
        color: #373C46;
      }
    }

    &-location {
      color: #C8C8C8;
      &--action {
        font-weight: bold;
        color: #777777;
      }
    }
  }
</style>